import { jobFunction } from "./common";

export const jobFunctionMap = jobFunction.reduce((memo, v) => {
  memo.set(v.value, v.name);
  return memo;
}, new Map());

export const getJobFunction = (user) => (user?.jobFunction ? jobFunctionMap.get(user.jobFunction) || "" : "");
